import React from 'react';
import PropTypes from 'prop-types';
import { itmToQueryString } from 'utils/itm';
import { Image } from 'components';
const Slide = ({ item, itm }) => {
    const url = `${item.url}${itmToQueryString(itm)}${
        itm ? '&sortBy=MostBids' : '?&sortBy=MostBids'
    }`;

    const ItemIcon = item.icon && item.icon;
    return (
        <div className="col">
            <a href={url}>
                <picture>
                    <Image
                        src={item.image}
                        srcset={`${item.image} 400w`}
                        sizes={`(min-width: 0)`}
                        alt={`visa mer ${item.text}`}
                        className="img-fluid image-nav--img"
                    />
                    {item.text && (
                        <div className="d-flex h-100 w-100 align-items-center justify-content-center image-nav--text">
                            <div className="w-75">
                                {ItemIcon && (
                                    <span className="text-white w-100 d-flex pb-3">
                                        <ItemIcon className="icon icon-white icon-xl m-auto" />
                                    </span>
                                )}
                                <p className="text-white text-justify text-center">
                                    {item.text}
                                </p>
                            </div>
                        </div>
                    )}
                </picture>
            </a>
        </div>
    );
};

Slide.propTypes = {
    item: PropTypes.shape({
        text: PropTypes.string,
        url: PropTypes.string,
        //icon is expected to be a react component
        // icon: PropTypes.node,
        image: PropTypes.string.isRequired
    })
};

export default Slide;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/carousels/image-nav/slide.jsx